import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
@pbi.Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: [
        '../../../assets/pages/css/profile.min.css'
    ]
})
export class ProfileComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    curPass: string = "";
    newPass: string = "";
    newPassAgain: string = "";
    FullName: string = "";
    eMail: string = "";
    Phone: string = "";
    More: string = "";
    Avatar: string = this.pb_func.NotImage;
    fileAvatar: any = null;

    constructor(private adminService: AdminService) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        this_sav.pb_func.loadScript([
            'assets/global/plugins/jquery.sparkline.min.js',
            //'assets/global/scripts/app.min.js',
            'assets/pages/scripts/profile.min.js',
            'assets/more/script/fixHeightContent.js'
            //'assets/layouts/layout/scripts/layout.min.js',
            //'assets/layouts/layout/scripts/demo.min.js',
            //'assets/layouts/global/scripts/quick-sidebar.min.js'
        ], 'profile', function () {
            this_sav.adminService.closeLoading(function () {
                this_sav.ShowInfo();
            });
        });
    };

    ChangePassword() {
        var this_sav = this;
        var data = { curPass: this_sav.curPass, newPass: this_sav.newPass, newPassAgain: this_sav.newPassAgain };
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/User/changePass', 'POST', data, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                let className = 'success';
                if (status == 0) { className = 'error'; }
                $('#BtnChangePassword').notify(mess, { position: "right", className: className });
            });
        });
    }

    ShowInfo(){
        var this_sav = this;
        this_sav.adminService.getUserInfo(function(result) {
            this_sav.FullName = result.FullName;
            this_sav.eMail = result.eMail;
            this_sav.Phone = result.Phone;
            this_sav.More = result.More;
            this_sav.Avatar = result.Avatar;
        });
    }

    GetInfo() {
        var this_sav = this;
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/User/Info', 'POST', {get:null}, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 1) {
                    var json_mes = JSON.parse(mess);
                    this_sav.adminService.setUserInfo(
                        json_mes.FullName,json_mes.eMail,json_mes.Phone,json_mes.More,json_mes.Avatar
                    );
                    this_sav.ShowInfo();
                }
                else {
                    console.error('ghhgjghj');
                }
            });
        });
    }

    UpdateInfo() {
        var this_sav = this;
        this_sav.adminService.openLoading1();
        let formData: FormData = new FormData();
        formData.append("FullName", this_sav.FullName);
        formData.append("eMail", this_sav.eMail);
        formData.append("Phone", this_sav.Phone);
        formData.append("More", this_sav.More);
        formData.append("Avatar", this_sav.fileAvatar);

        this_sav.pb_func.callAPI('api/User/UpdateInfo', 'POST', formData, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                let className = 'success';
                if (status == 0) {
                    className = 'error';
                }
                else {
                    this_sav.GetInfo();
                }
                $('#BtnChangeInfo').notify(mess, { position: "right", className: className });
            });
        });
    }

    ChangeAvatar($event){
        var a = $event.currentTarget;
        $(a).find('input[type="file"]').click();
    }

    readAvatar($event) {
        var this_sav = this;
        var reader = new FileReader();
        reader.onload = function (ee) {
            this_sav.Avatar = reader.result;
        };

        try {
            this_sav.fileAvatar = $event.currentTarget.files[0]; 
            reader.readAsDataURL(this_sav.fileAvatar);
        }
        catch(r) {
            this_sav.Avatar =  this_sav.pb_func.NotImage;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/profile/profile.component.ts